import { render, staticRenderFns } from "./previewArticulos.vue?vue&type=template&id=04e7ac23&"
import script from "./previewArticulos.vue?vue&type=script&lang=js&"
export * from "./previewArticulos.vue?vue&type=script&lang=js&"
import style0 from "./previewArticulos.vue?vue&type=style&index=0&id=04e7ac23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports